import { useIdle, useVisibilityChange } from '@uidotdev/usehooks';

const DEFAULT_IDLE_TIMEOUT_MS = 15 * 60 * 1000; // 15 minutes

/**
 * True when the user is present and engaged: the tab is visible AND there has
 * been user input within `idleTimeoutMs`. Use this to gate background polling
 * so idle or hidden tabs stop hitting the API. Polling resumes the moment the
 * user returns.
 */
export function useActive(idleTimeoutMs: number = DEFAULT_IDLE_TIMEOUT_MS): boolean {
  const visible = useVisibilityChange();
  const idle = useIdle(idleTimeoutMs);

  return visible && !idle;
}
